import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  margin: 0;
  padding-left: ${props => props.theme.spacing.sp24};
  max-height: 160px;
  overflow-y: auto;
`

export const Item = styled.li`
  &::marker {
    color: ${props => props.theme.colors.text.default};
  }
`

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
